import { cn } from '@/lib/utils'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'

interface IUserTab {
  countTabs?: Record<string, number>
  value: string
  onChange: (value: string) => void
}

const options = [
  { label: 'Active', value: 'active' },
  { label: 'Deactivated', value: 'deactivated' },
  { label: 'Invited', value: 'invited' },
]

export function UserTab({ countTabs, value, onChange }: IUserTab) {
  const handleTabChange = (value: string) => {
    onChange(value)
  }

  const total =
    (countTabs?.active ?? 0) +
    (countTabs?.deactivated ?? 0) +
    (countTabs?.invited ?? 0)

  return (
    <Tabs
      value={value}
      onValueChange={handleTabChange}
      className="w-full md:border md:border-[#D5D5D5] rounded-[10px] md:rounded-r-[0px] h-[38px]"
    >
      <TabsList
        className="flex w-full overflow-x-auto"
        style={{
          flexWrap: 'nowrap',
          overflowX: 'auto',
          overflowY: 'hidden',
          WebkitOverflowScrolling: 'touch',
          scrollbarWidth: 'thin',
        }}
      >
        <div className="flex min-w-full justify-between sm:justify-start">
          <TabsTrigger
            value="all"
            className={cn(
              'text-sm data-[state=active]:bg-transparent !shadow-none data-[state=active]:text-primary  flex flex-row sm:gap-1',
              value === 'all' && 'text-primary font-bold'
            )}
          >
            <p>All</p>
            <p>({total})</p>
          </TabsTrigger>
          {options.map((option) => {
            return (
              <TabsTrigger
                key={option.value}
                value={option.value}
                className={cn(
                  'text-sm data-[state=active]:bg-transparent !shadow-none data-[state=active]:font-bold data-[state=active]:text-primary flex flex-row sm:gap-1'
                )}
              >
                <p>{option.label}</p>
                <p> ({countTabs?.[option.value]})</p>
              </TabsTrigger>
            )
          })}
        </div>
      </TabsList>
    </Tabs>
  )
}
